export const LEGACY_GROUP_TENANT_ID = "68b3c2e9603397c62fc2d835";
